import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "./App.css"
import Home from './components/Home/Home';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import AboutUs from './components/about/About';
import ContactPage from './components/Contact/Contact';
import Leadermessage from './components/Leadermessage/Leadermessage';
import WhyUsPage from './components/whyuspage/Whyus';





export default function App() {
  return (
    <>
       <Router>
     <Navbar/>
          <Routes>
            {/* <Route path="/about" element={<About/>} /> */}
            <Route path="/" element={<Home/>}/>
            <Route path="/about" element={<AboutUs/>}/>
              <Route path="/contact" element={<ContactPage/>}/>
              <Route path="/whyus" element={<WhyUsPage/>}/>
     <Route path="/director" element={<Leadermessage/>}/>
          </Routes>  
        <Footer/>
        </Router>
    </>
  )
}
